import s from './billing.module.scss';

interface UsageMeterProps {
  label: string;
  current: number;
  limit: number;
}

export function UsageMeter({ label, current, limit }: UsageMeterProps) {
  const isUnlimited = !isFinite(limit);
  const pct = isUnlimited ? 0 : Math.min((current / limit) * 100, 100);
  const severity = pct >= 90 ? 'critical' : pct >= 70 ? 'warning' : 'normal';

  return (
    <div className={s.usageMeter}>
      <div className={s.usageMeterHeader}>
        <span className={s.usageMeterLabel}>{label}</span>
        <span className={s.usageMeterValue}>
          {current.toLocaleString()}
          {isUnlimited ? '' : ` / ${limit.toLocaleString()}`}
        </span>
      </div>
      {!isUnlimited && (
        <div className={s.usageMeterTrack}>
          <div
            className={s.usageMeterFill}
            data-severity={severity}
            style={{ width: `${pct}%` }}
          />
        </div>
      )}
    </div>
  );
}
